import React from "react";
import ActionItems from "./ActionItems";
import PrivateTags from "./PrivateTags";
import ActivityLog from "./ActivityLog";
import UnblockRequest from "./UnblockRequest";
import ModeratorBlog from "./ModeratorBlog";

const ManageContent = ({
  subMenuItem,
  tenantId,
  tenantName,
  type,
  decreaseActionItemCount,
  decreaseUnblockRequestCount,
  isPm,
}) => {
  return (
    <div>
      {subMenuItem === "Private Tags" ? (
        <PrivateTags tenantId={tenantId} tenantName={tenantName} isPm={isPm} />
      ) : subMenuItem === "Activity Log" ? (
        <ActivityLog tenantId={tenantId} tenantName={tenantName} type={type} />
      ) : subMenuItem === "Unblock Requests" ? (
        <UnblockRequest
          tenantId={tenantId}
          tenantName={tenantName}
          decreaseUnblockRequestCount={decreaseUnblockRequestCount}
        />
      ) : subMenuItem === "Moderator Blog" ? (
        <ModeratorBlog tenantId={tenantId} tenantName={tenantName} />
      ) : (
        <ActionItems
          tenantId={tenantId}
          tenantName={tenantName}
          decreaseActionItemCount={decreaseActionItemCount}
        />
      )}
    </div>
  );
};

export default ManageContent;
